import Swiper, {Navigation, Pagination, EffectFade, Autoplay, Scrollbar} from 'swiper';

Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Scrollbar]);

class ConfigurationSlider {
  public element: any;
  public mainCarouselEl: HTMLElement;
  public featureCarouselEl: HTMLElement;
  public paginationEl: HTMLElement;
  public nextAreaEl: HTMLElement;
  public mainCarousel: Swiper;
  public featureCarousel: Swiper;

  constructor(element: HTMLElement) {
    this.element = element;
    this.mainCarouselEl = this.element.querySelector('.js-o-configuration-slider');
    this.featureCarouselEl = this.element.querySelector('.js-o-configuration-slider__features');
    this.paginationEl = this.element.querySelector('.o-configuration-slider__pagination');
    this.nextAreaEl = this.element.querySelector('.swiper-button-next--area');
  }

  initMainSwiper() {
    // console.log('init main slider');
    this.mainCarousel = new Swiper(this.mainCarouselEl, {
      effect: 'slide',
      speed: 800,
      slidesPerView: (window.innerWidth >= 1024 ? 1.15 : 1),
      spaceBetween: 0,
      loop: true,
      navigation: {
        prevEl: this.element.querySelector('.swiper-button-prev'),
        nextEl: this.element.querySelector('.swiper-button-next'),
      },
      grabCursor: true,
      centeredSlides: (window.innerWidth >= 1024 ? false : true),
      pagination: {
        el: this.paginationEl,
        type: 'bullets',
        clickable: true,
      }
    });

    if (this.nextAreaEl) {
      this.nextAreaEl.addEventListener('click', () => {
        this.mainCarousel.slideNext();
      });
    }
  }

  initFeatureSwiper() {
    // console.log('init feature slider');
    this.featureCarousel = new Swiper(this.featureCarouselEl, {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 800,
      slidesPerView: 1,
      spaceBetween: 0,
      allowSlideNext: false,
      allowSlidePrev: false,
      loop: true,
      centeredSlides: (window.innerWidth >= 1024 ? false : true)
    });

    this.featureCarousel.update();

    this.featureCarousel.slideToLoop(this.mainCarousel.realIndex);

    this.mainCarousel.on('transitionStart', () => {
      this.featureCarousel.allowSlidePrev = true;
      this.featureCarousel.allowSlideNext = true;
      this.featureCarousel.slideToLoop(this.mainCarousel.realIndex);
      this.featureCarousel.allowSlidePrev = false;
      this.featureCarousel.allowSlideNext = false;
    });
  }

  init() {
    this.initMainSwiper();
    this.initFeatureSwiper();

    setTimeout(() => {
      this.mainCarousel.update();
      this.featureCarousel.update();
    }, 2000);
  }
}

export default ConfigurationSlider;
